<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        header="Log"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-4"
        modal >

            <div class="w-full">
                <div class="field">
                    <Select id="select" v-model="log" optionLabel="id" :options="logOpt" :loading="isLoading" class="w-full">
                        <template #value="{value}">
                            <template v-if="value">
                                <div class="flex items-center">
                                    <span class="font-bold mr-1">{{ value.operacao }}</span> {{ dataFormat(value.created_at) }} ({{ value.usuario }})
                                </div>
                            </template>
                        </template>

                        <template #option="{option}">
                            <div class="flex items-center">
                                <span class="font-bold mr-1">{{ option.operacao }}</span> {{ dataFormat(option.created_at) }} ({{ option.usuario }})
                            </div>
                        </template>
                    </Select>
                </div>

                <ScrollPanel v-if="log && log.id" style="height: 65vh">
                    <!-- Motivo gravado na linha de log (hoje só alterações de conta trazem).
                         Só aparece quando existe — nas outras telas nada muda. -->
                    <div v-if="log.justificativa" class="mt-3">
                        <h4 class="mb-1">Justificativa:</h4>
                        <p class="log-justificativa mt-0">{{ log.justificativa }}</p>
                    </div>
                    <div v-if="log && log.objeto" style="margin-top: 1em;">
                        <h4>Conteúdo:</h4>
                        <ul v-for="(value, key) in parseContentLog(log.objeto)" :key="key"
                            style="list-style: none;">
                            <li><strong>{{ key }}</strong>:</li>
                            <ul>
                                <li v-if="value.old"><strong>Antigo:</strong> {{ value.old }}</li>
                                <li v-if="value.new"><strong>Novo:</strong> {{ value.new }}</li>
                            </ul>
                        </ul>
                    </div>
                </ScrollPanel>
            </div>


            <div class="flex justify-content-end gap-1">
                <Button
                    label="Fechar"
                    severity="warn"
                    icon="pi pi-times"
                    size="small"
                    @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center"
                    :loading="isLoading" />
            </div>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import Button from 'primevue/button';
import ScrollPanel from 'primevue/scrollpanel';
import Tag from 'primevue/tag';

import Log from '@/service/log.js';

import Moment from 'moment';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        Select,
        ScrollPanel,
        Tag,
    },
    props: {
        visible: false,
        table: '',
        tableId: 0,
    },
    emits: ['close'],
    data() {
        return {
            log: {},
            logOpt: [],
            isLoading: false,
        }
    },
    methods: {
        dataFormat(value) {
            if (!value) return;
            return Moment.utc(value).local().format("DD/MM/YYYY HH:mm");
        },
        parseContentLog(content) {
            try {
                return JSON.parse(content);
            } catch (error) {
                return {};
            }
        },
        onShow() {
            this.logOpt = [];
            this.loadLogOpt();
        },
        onHide() {
            this.form = {};
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        loadLogOpt() {
            this.isLoading = true;
            Log.option(this.table, this.tableId, ["order[id]=desc"].join("&")) 
                .then(response => {
                    this.logOpt = response.data;
                    if(this.logOpt && this.logOpt.length) {
                        this.log = this.logOpt[0];
                    }
                })
                .finally(() => this.isLoading = false);
        }
    }
}
</script>

<style scoped>
/* Texto livre do usuário: mantém as quebras de linha e não estoura a largura do diálogo. */
.log-justificativa {
    white-space: pre-line;
    overflow-wrap: anywhere;
}
</style>
